import React from 'react'
import { Offer } from '../models/shared/Offer';
import { useText } from '../context/TextContext';

interface Props {
    offer?: Offer | null
}
export default function OfferState({ offer }: Props) {
    const text = useText();

    let status = text.noOffer;
    if (offer) {
        status = text.pending;

        if (offer.acceptedAt) {
            status = text.accepted
        } else if (offer.auditRecords?.length) {
            status = text.viewed
        }
    }

    return <span className={offer?.acceptedAt ? 'text-success' : ''}>({status})</span>
}
